import React from "react";
import ChannelsList from "../ChannelsList";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import apiClient from "../../utils/apiClient";
import { CircularProgress } from "@mui/material";

const SportsChannels = () => {
  const [search, setSearch] = useState("");
  const [events, setEvents] = useState([]);

  const [loadingEvents, setLoadingEvents] = useState(false);

  const getEvents = async () => {
    try {
      setLoadingEvents(true);

      const response = await apiClient.get('/public/channel')
      const result = await response?.data;

      if (result?.success) {
        setEvents(result.data);
      }

    } catch (error) {
      console.log("Country API Error:", error);
    } finally {
      setLoadingEvents(false);
    }
  };

  useEffect(() => {
    getEvents();
  }, []);


  if (loadingEvents) {
    return (
      <div className="flex justify-center py-6">
        <CircularProgress size={24} />
      </div>
    )
  }

  const filteredChannels = events.filter(
    (item) => {

      const searchText =
        search?.toLowerCase()?.trim();

      const channelName =
        item?.channel_name
          ?.toLowerCase() || "";

      const shortTitle =
        item?.short_title
          ?.toLowerCase() || "";

      return (
        channelName.includes(searchText) ||
        shortTitle.includes(searchText)
      );
    }
  );

  return (
    <div className="container mx-auto px-4 max-w-6xl py-6">

      {/* Header */}
      <div className="flex items-center justify-between mb-4">

        <div className="flex items-center gap-3">

          {/* Icon */}
          <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-blue-500/20">
            📡
          </div>

          <h2 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
            Sports Channels
          </h2>

        </div>

        <Link
          to="/channels"
          className="text-sm font-medium text-blue-500 hover:text-blue-600 flex items-center gap-1"
        >
          View All ➜
        </Link>

      </div>

      {
        filteredChannels?.slice(0, 12)?.length > 0 ? (
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2">
            <ChannelsList channels={filteredChannels?.slice(0, 12)} />
          </div>
        ) : (
          <div className="w-full py-10 flex items-center justify-center">
            <h2 className="text-lg font-semibold text-gray-500">
              No Channels Found
            </h2>
          </div>
        )
      }
    </div>
  );
};

export default SportsChannels;